import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonMenuButton, IonPage, IonRow, IonTitle, IonToolbar, useIonRouter, useIonToast, useIonViewWillEnter } from '@ionic/react';
import { addCircleOutline, at} from 'ionicons/icons';
import React, { useRef, useState } from 'react';
import { useAppContext } from '../AppProvider';
import Alert from '@mui/material/Alert';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { AlertTitle } from '@mui/material';

const ContactCreate: React.FC = () => {  
    const [showToast] = useIonToast();
    const phoneInputRef = useRef<any>();  
    const formRef = useRef<any>(null);

    const router = useIonRouter();

    const { networkStatus, getAppStatus, authKey, authenticateMember, setShowLoader, limits, profiles, settings, getCountries, SWFullHorizLogo, SWTextDarkLogo } = useAppContext();    
    
    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const appstat = await getAppStatus();
            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                const authenticated = await authenticateMember();   
                if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
                else {
                    await getCountries(); 
                    setShowLoader(false);
                }
            }
        };
        authenticate();
    }); 

    const insertContact = async (e: any) => {
        e.preventDefault();
        const form = e.target; 
        const formName = form.name;
        const btn: any = document.getElementById(formName + 'Submit');
        btn.innerHTML = 'Sending...';
        btn.setAttribute('disabled', '');
        const formData = new FormData(form);
        formData.append('mt', authKey.mt);
        
        try {
            const response = await fetch('https://api.besolowise.com/contacts/insert/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                    
                //if(obj.success) router.push('/account/contact/edit/' + obj.ct, 'back');
                if(obj.success) {
                    formRef.current.reset();                
                    router.push('/account/contacts', 'forward');
                } else {
                    showToast({
                        message: 'Error: ' + obj.message,
                        duration: 5000,
                        color: 'danger',
                    });
                }
            } else {
                btn.innerHTML = 'Save';
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                });
            } 
        } catch(error) {
            showToast({
                message: 'Connection Error: Couldn\'t create this emergency contact. ' + error + '. Try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerLink='/account/contacts'>Contacts</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" fullscreen>  
                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon color={'secondary'} icon={at}></IonIcon> New Contact<br /><span>Set up a new emergency contact</span></h1>
                        </IonCol>
                    </IonRow>
                </IonGrid>

                {profiles?.contacts >= limits?.contacts &&
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                You've reached the limit of Contacts for your current plan.
                            </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can add more Contacts by upgrading to a SoloWise Premium plan. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>                            
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                            </p>
                        </IonCardContent>
                    </IonCard>
                }      

                {profiles?.contacts < limits?.contacts &&
                    <>
                        <div className='ion-padding'>
                            <Alert
                                severity="info"
                                icon={<InfoOutlinedIcon fontSize="inherit" />}
                                sx={{
                                borderRadius: 2,
                                mb: 2
                                }}
                            >
                                <AlertTitle>Important:</AlertTitle>
                                <div className='ion-margin-top'>
                                    Before you send an emergency contact agreement to someone by submitting this form, we strongly suggest informing that person to expect an email from SoloWise. Otherwise, an unexpected email from SoloWise could appear as spam or a phishing scheme to someone not aware of our service. This could cause the recipient to decline or delete the email. By informing your contacts to expect the email, you can increase the odds of your contact accepting your request on the first attempt.
                                </div>
                            </Alert>
                        </div>
                
                        <IonCard>
                            <IonCardContent>
                                <form name='contactForm' onSubmit={insertContact} ref={formRef}>
                                    <IonGrid>

                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Full Name</b> <em className='required'>Required</em></IonLabel>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='contactFirstName' placeholder='First Name' type='text'></IonInput>
                                            </IonCol>
                                            <IonCol size='6'>
                                                <IonInput fill='outline' name='contactLastName' placeholder='Last Name' type='text'></IonInput>
                                            </IonCol>                                   
                                        </IonRow>

                                        <IonRow>
                                            <IonCol size='12'>
                                                <IonLabel color={'dark'}><b>Email</b> <em className='required'>Required</em></IonLabel>
                                            </IonCol>
                                            <IonCol size='12'>
                                                <IonInput fill='outline' name='contactEmail' placeholder='Email Address' type='email'></IonInput>                                        
                                            </IonCol>
                                        </IonRow>

                                        <IonRow>
                                            <IonCol size='12' className='ion-text-wrap'>
                                                <IonCheckbox color={'secondary'} labelPlacement="end" name='contactNotified'>I have told this contact to<br />expect an email from SoloWise.</IonCheckbox>                                        
                                            </IonCol>
                                        </IonRow>

                                        <IonRow className='ion-margin-top'>
                                            <IonCol size='12'>
                                                <IonCheckbox color={'secondary'} labelPlacement="end" name='contactAlwaysUse'>Automatically add to my Timers.<br />(<em>You can change this later.</em>)</IonCheckbox>                                        
                                            </IonCol>
                                        </IonRow>

                                    </IonGrid>
                                    
                                    <IonButton className='ion-margin-top' color={'secondary'} expand="block" id='contactFormSubmit' type='submit'>
                                        Send Contact Agreement
                                    </IonButton>
                                </form>
                            </IonCardContent>
                        </IonCard>
                    </>
                }
            </IonContent>
        </IonPage>
    );
};

export default ContactCreate;